
import React, { Component } from "react";
import { translations } from "../../../translate.js";
import {
    UncontrolledDropdown,
    Row,
    Col,
    Card,
    CardBody,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalBody,
} from "reactstrap";
import { Button, Drawer } from "@material-ui/core";
import { confirmAlert } from "react-confirm-alert";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Pagination from "react-js-pagination";
import { Picky } from "react-picky";
import { eyeIcon } from '../settings/AppImagesSettings/icons';
import "react-picky/dist/picky.css";
import SearchIcon from "@material-ui/icons/Search";
import { toAbsoluteUrl } from "../../../_metronic/index.js";
import ShowEFAWATEERcomData from "./forms/showEFAWATEERcomData.jsx";
// import ShowUWalletData from "./forms/showUWalletData.jsx";


let Strings =
    localStorage.getItem("LANG") == 1 ? translations.Ar : translations.En;
let today = new Date();
let currentDate =
    today.getFullYear() +
    "-" +
    ("0" + (today.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + today.getDate()).slice(-2);

export default class eFAWATEERcomReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: 0,
            limit: 10,
            activePage: 1,
            dataCount: 0,
            errorMsg: "",
            fromDate: currentDate,
            toDate: currentDate,
            data: [],
            distributorList: [],
            distId: [],
            posList: [],
            selectedPos: [],
            umniahLookupTypes: [],
            selectedOrderId: [],
            openShowEFAWATEERcomReportData: false,
            showEFAWATEERcomReportData: null,
            serviceType: "",
            billerCategory: "",
            billerName: "",
        };
    }
    openSidebarModal = () => {
        this.setState({ openleftModal: !this.state.openleftModal });
    };
    closeSidebarModal = () => {
        this.setState({ openleftModal: false }, () => {
            this.handleSearch();
        });
    };
    openSidebarModal2 = (modalData = null) => {
        this.setState({ openModal: !this.state.openModal, modalData });
    };
    closeSidebarModal2 = () => {
        this.setState({ openModal: false, modalData: null }, () => { });
    };
    handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === "checkbox" ? target.checked : target.value;
        this.setState(
            {
                [name]: value,
                activePage: 1,
            }
        );
    };




    handleChangeSelect = (type, option) => {
        console.log(option);
        this.setState(
            (state) => {
                return {
                    [type]: option,
                    activePage: 1,
                    errorMsg: 0,
                };
            },
            () => {
                if (type == "distId") {
                    // Clear selected POS when distributor changes
                    this.setState({ selectedPos: [], posList: [] }, () => {
                        this.getPos();
                    });
                }
            }
        );
    };

    getSelected = (type) => {
        if (type === "dist") {
            return this.state.distId.map(dist => dist.userId);
        }
        if (type === "selectedPos") {
            return this.state.selectedPos ? this.state.selectedPos.map(pos => pos.userId) : [];
        }
        if (type === "selectedOrderId") {
            return this.state.selectedOrderId ? this.state.selectedOrderId.map(order => order.Value) : [];
        }
        return [];
    };

    handleRefresh = () => {
        this.setState(
            {
                loading: 0,
                limit: 10,
                activePage: 1,
                dataCount: 0,
                errorMsg: "",
                fromDate: currentDate,
                toDate: currentDate,
                data: [],
                distributorList: [],
                distId: [],
                posList: [],
                selectedPos: [],
                billerCategory: "",
                billerName: "",
                serviceType: "",

            },
            function () {
                if (localStorage.getItem("USER_LEVEL") == 1) {
                    this.getAllDist();
                }

                this.getData();
            }
        );
    };

    getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
        const day = String(today.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    getMinDate = (POS_DAYS_NUM) => {
        const today = new Date();
        // Adjust the date by subtracting POS_DAYS_NUM days
        const pastDate = new Date(today);
        pastDate.setDate(today.getDate() - POS_DAYS_NUM);

        // Ensure proper formatting
        const pastYear = pastDate.getFullYear();
        const pastMonth = String(pastDate.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
        const pastDay = String(pastDate.getDate()).padStart(2, "0");

        return `${pastYear}-${pastMonth}-${pastDay}`;
    };
    handleSearch = async () => {
        this.setState({ loading: 1, errorMsg: "" });
        fetch(window.API_PERM_USER, {
            method: "POST",
            body: JSON.stringify({
                type: "getEfwatercomReport",
                token: localStorage.getItem("USER_TOKEN"),
                userId: localStorage.getItem("USER_ID"),
                fromAdmin: localStorage.getItem("USER_LEVEL") == 1 ? 1 : 0,
                lang: localStorage.getItem("LANG"),
                page: this.state.activePage,
                limit: this.state.limit,
                distId: this.getSelected("dist"),
                posId: this.getSelected("selectedPos"),
                fromDate: this.state.fromDate,
                toDate: this.state.toDate,
                serviceType: this.state.serviceType,
                billerCategory: this.state.billerCategory,
                billerName: this.state.billerName,
            }),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then(response => response.json())
            .then(data => {
                if (this._isMounted === false) return;

                if (data !== "Nothing found") {
                    if (data.logout === 1) {
                        localStorage.setItem("USER_ID", "");
                        localStorage.setItem("USER_TOKEN", "");
                        window.location.href = "/logout";
                    } else if (data.reportInfo && Array.isArray(data.reportInfo)) {
                        this.setState({
                            data: data.reportInfo,
                            dataCount: data.count,
                            loading: 0
                        });
                    } else {
                        this.setState({
                            data: data.data,
                            dataCount: data.count,
                            loading: 0
                        });
                    }
                }
            })
            .catch(error => {
                if (this._isMounted === false) return;

                console.error("Error fetching data:", error);
                this.setState({
                    data: [],
                    dataCount: 0,
                    errorMsg: "Error fetching data",
                    loading: 0
                });
            });
    };
    componentDidMount() {
        this._isMounted = true;
        if (localStorage.getItem("USER_LEVEL") == 2) {
            this.getPos();
        }
        else if (localStorage.getItem("USER_LEVEL") == 1) {
            this.getAllDist();
        }
        this.getData();
    }

    componentWillUnmount() {
        // Prevent memory leaks by canceling any pending state updates
        this._isMounted = false;
    }
    getAllDist = () => {
        fetch(window.API_PERM_USER, {
            method: "POST",
            body: JSON.stringify({
                type: "getAllDist",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                getType: "all",
            }),
            headers: {
                Accept: "application/json",
            },
        })
            .then(function (response) {
                return response.json();
            })
            .then((data) => {
                if (this._isMounted === false) return;

                if (data !== "Nothing found") {
                    if (data["logout"] == 1) {
                        localStorage.setItem("USER_ID", "");
                        localStorage.setItem("USER_TOKEN", "");
                        window.location.href = "/logout";
                    } else {
                        this.setState({ distributorList: data["data"] }, function () { });
                    }
                }
            });
    };
    getData() {
        this.setState({ loading: 1, errorMsg: "" });
        fetch(window.API_PERM_USER, {
            method: "POST",
            body: JSON.stringify({
                type: "getEfwatercomReport",
                token: localStorage.getItem("USER_TOKEN"),
                userId: localStorage.getItem("USER_ID"),
                fromAdmin: localStorage.getItem("USER_LEVEL") == 1 ? 1 : 0,
                lang: localStorage.getItem("LANG"),
                page: this.state.activePage,
                distId: this.getSelected("dist"),
                posId: this.getSelected("selectedPos"),
                limit: this.state.limit,
                fromDate: this.state.fromDate,
                toDate: this.state.toDate,
                serviceType: this.state.serviceType,
                billerCategory: this.state.billerCategory,
                billerName: this.state.billerName,
            }),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then(response => response.json())
            .then(data => {
                if (this._isMounted === false) return;

                if (data !== "Nothing found") {
                    if (data.logout === 1) {
                        localStorage.setItem("USER_ID", "");
                        localStorage.setItem("USER_TOKEN", "");
                        window.location.href = "/logout";
                    } else if (data.reportInfo && Array.isArray(data.reportInfo)) {
                        this.setState({
                            data: data.reportInfo,
                            dataCount: data.count,
                            loading: 0
                        });
                    } else {
                        this.setState({
                            data: data.data,
                            dataCount: data.count,
                            loading: 0
                        });
                    }
                }
            })
            .catch(error => {
                if (this._isMounted === false) return;

                console.error("Error fetching data:", error);
                this.setState({
                    data: [],
                    dataCount: 0,
                    errorMsg: "Error fetching data",
                    loading: 0
                });
            });
    }
    getPos() {
        fetch(window.API_PERM_USER, {
            method: "POST",
            body: JSON.stringify({
                type: "getDistPos",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                distId: localStorage.getItem("USER_LEVEL") == 1 ? this.getSelected("dist") : localStorage.getItem("USER_ID"),
                allPos: "0",
                getType: "all",
            }),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (data !== "Nothing found") {
                    if (data["logout"] == 1) {
                        localStorage.setItem("USER_ID", "");
                        localStorage.setItem("USER_TOKEN", "");
                        window.location.href = "/logout";
                    } else {
                        this.setState({
                            posList: data["data"]
                        });
                        console.log(data["data"]);
                    }
                } else {
                    this.setState({
                        posList: [],
                    });
                }
            })
            .catch((error) => {
                console.error("Error fetching POS data:", error);
                this.setState({
                    posList: [],
                });
            });
    }

    handlePageChange = (pageNumber) => {
        this.setState({ activePage: pageNumber }, function () {
            this.handleSearch();
        });
    };
    exportHandler = () => {
        const params = {
            type: "getUmniahPaymentApiReport",
            token: localStorage.getItem("USER_TOKEN"),
            userId: localStorage.getItem("USER_ID"),
            fromAdmin: localStorage.getItem("USER_LEVEL") == 1 ? 1 : 0,
            lang: localStorage.getItem("LANG"),
            page: this.state.activePage,
            limit: this.state.limit,
            distId: this.getSelected("dist"),
            posId: this.getSelected("selectedPos"),
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            rechargeType: this.getSelected("selectedOrderId"),
            export: 1
        };
        const queryString = new URLSearchParams(params).toString();
        window.location = `${window.API_PERM_USER_EXPORT}?${queryString}`;
    };
    handleShowEFAWATEERcomReportData = (rowData) => {
        this.setState({ openShowEFAWATEERcomReportData: true, showEFAWATEERcomReportData: rowData });
    }
    render() {
        const col = localStorage.getItem("USER_LEVEL") == 1 ? 2 : 3;
        return (
            <div>


                <Row>
                    <Col lg={12} className="main-color-1 inv-class-view-title mb-4">
                        <div>
                            {Strings["E-fawatercom Requests Report"]}
                        </div>
                        <hr className="inv-hr-view-2" />
                    </Col>
                </Row>
                <Row className="page-filter-view">
                    <Col
                        xl={{ size: 5, order: 1 }}
                        lg={{ size: 7, order: 1 }}
                        md={{ size: 7, order: 1 }}
                        sm={{ size: 10, order: 1 }}
                        xs={{ size: 12, order: 1 }}
                    >
                        <AvForm ref={(c) => (this.form = c)}>

                            <Row className="filter-form">

                                {localStorage.getItem("USER_LEVEL") == 1 && (
                                    <Col lg={12} md={12} sm={12} xs={12} className="d-flex justify-content-between">

                                        <Col xs={10} lg={10} md={10} sm={10} className="p-0">
                                            <div className="member-searchable-list mb-2 mt-2">
                                                <Picky
                                                    value={this.state.distId}
                                                    options={this.state.distributorList}
                                                    onChange={this.handleChangeSelect.bind(this, "distId")}
                                                    open={false}
                                                    valueKey="userId"
                                                    labelKey="fname"
                                                    multiple={true}
                                                    includeSelectAll={true}
                                                    includeFilter={true}
                                                    dropdownHeight={200}
                                                    placeholder={Strings["Distributor Name"]}
                                                    filterPlaceholder={Strings["Select Distributor Name"]}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={2} lg={2} md={2} sm={2} className="d-flex align-items-center" style={{ padding: "0px 10px" }}>
                                            <Button
                                                variant="contained"
                                                type="button"
                                                className="refresh-action-btn "
                                                onClick={this.handleRefresh}
                                                title={Strings["Refresh"]}
                                            >
                                                <i className="flaticon-refresh reset-filter-btn"></i>
                                            </Button>
                                        </Col>
                                    </Col>
                                )}

                                {(localStorage.getItem("USER_LEVEL") == 1 || localStorage.getItem("USER_LEVEL") == 2) && (
                                    <Col lg={10} md={10} sm={12} xs={12}>
                                        <div className="member-searchable-list mb-2">
                                            <Picky
                                                value={this.state.selectedPos}
                                                options={this.state.posList}
                                                onChange={this.handleChangeSelect.bind(this, "selectedPos")}
                                                open={false}
                                                valueKey="userId"
                                                labelKey="fullName"
                                                multiple={true}
                                                includeSelectAll={true}
                                                includeFilter={true}
                                                dropdownHeight={200}
                                                placeholder={Strings["POS"]}
                                                filterPlaceholder={Strings["Select POS"]}
                                                selectAllText={Strings["Select All"]}
                                                allSelectedPlaceholder={Strings["%s selected"]}
                                                manySelectedPlaceholder={Strings["%s selected"]}
                                                clearFilterOnClose={true}
                                            />
                                        </div>
                                    </Col>
                                )}

                                {(localStorage.getItem("USER_LEVEL") == 1 || localStorage.getItem("USER_LEVEL") == 2) && (
                                    <Col lg={12} md={12} sm={12} xs={12} className="d-flex flex-column flex-md-row mt-3 mt-md-0 efawateer-flex-responsive">
                                        <Col lg={4} md={4} sm={12} xs={12} >
                                            <AvField
                                                name="billerCategory"
                                                type="text"
                                                value={this.state.billerCategory}
                                                onChange={this.handleInputChange}
                                                errorMessage={Strings["This field is required"]}
                                                placeholder={Strings["Category"]}
                                            />
                                        </Col>
                                        <Col lg={4} md={4} sm={12} xs={12}>
                                            <AvField
                                                name="billerName"
                                                type="text"
                                                value={this.state.billerName}
                                                onChange={this.handleInputChange}
                                                errorMessage={Strings["This field is required"]}
                                                placeholder={Strings["Biller"]}
                                            />
                                        </Col>
                                        <Col lg={4} md={4} sm={12} xs={12}>
                                            <AvField
                                                name="serviceType"
                                                type="text"
                                                value={this.state.serviceType}
                                                onChange={this.handleInputChange}
                                                errorMessage={Strings["This field is required"]}
                                                placeholder={Strings["Service Name"]}
                                            />
                                        </Col>
                                    </Col>
                                )}




                                {/* {(localStorage.getItem("USER_LEVEL") == 1 || localStorage.getItem("USER_LEVEL") == 2) && (
                                    <Col lg={6} md={6} sm={6} xs={12}>
                                        <div className="member-searchable-list mb-2 ">
                                            <Picky
                                                value={this.state.selectedOrderId}
                                                options={this.state.umniahLookupTypes}
                                                onChange={this.handleChangeSelect.bind(
                                                    this,
                                                    "selectedOrderId"
                                                )}
                                                open={false}
                                                valueKey="Value"
                                                labelKey="Desc"
                                                multiple={true}
                                                includeSelectAll={true}
                                                includeFilter={true}
                                                dropdownHeight={200}
                                                placeholder={Strings["Card Type"]}
                                                filterPlaceholder={Strings["Select Card Type"]}
                                                selectAllText={Strings["Select All"]}
                                                allSelectedPlaceholder={Strings["%s selected"]}
                                                manySelectedPlaceholder={Strings["%s selected"]}
                                                clearFilterOnClose={true}
                                            // noneSelectedPlaceholder={Strings["Order ID"]}
                                            />
                                        </div>
                                    </Col>
                                )} */}

                                {(localStorage.getItem("USER_LEVEL") == 1 || localStorage.getItem("USER_LEVEL") == 2) && (
                                    <Col lg={6} md={6} sm={6} xs={12}>
                                        <AvField
                                            name="fromDate"
                                            type="date"
                                            label={`${Strings["From Date"]}`}
                                            value={this.state.fromDate}
                                            onChange={this.handleInputChange}
                                            errorMessage={Strings["This field is required"]}
                                        // max={this.getTodayDate()}
                                        // min={this.getMinDate(
                                        //   Number(localStorage.getItem("BILLS_DAYS_NUM"))
                                        // )}
                                        />
                                    </Col>
                                )}
                                {(localStorage.getItem("USER_LEVEL") == 1 || localStorage.getItem("USER_LEVEL") == 2) && (
                                    <Col lg={6} md={6} sm={6} xs={12}>
                                        <AvField
                                            name="toDate"
                                            type="date"
                                            label={`${Strings["To Date"]}`}
                                            value={this.state.toDate}
                                            onChange={this.handleInputChange}
                                            errorMessage={Strings["This field is required"]}
                                        // max={this.getTodayDate()}
                                        // min={this.getMinDate(
                                        //   Number(localStorage.getItem("BILLS_DAYS_NUM"))
                                        // )}
                                        />
                                    </Col>
                                )}
                            </Row>
                        </AvForm>
                    </Col>
                    <Col
                        xl={{ size: 7, order: 12 }}
                        lg={{ size: 5, order: 12 }}
                        md={{ size: 5, order: 12 }}
                        sm={{ size: 2, order: 12 }}
                        xs={{ size: 12, order: 12 }}
                        className="text-right mb-3 "
                    >
                        <div className="d-flex flex-wrap flex-column align-items-end gap-3 w-100">
                            <Col xs={12} lg={3} md={3} sm={12} className="p-0">
                                <button
                                    variant="contained"
                                    className="btn form-save-btn  mb-2 w-100"
                                    onClick={this.handleSearch}
                                >
                                    {Strings["Search"]}{" "}
                                    <SearchIcon className="font-size-15  main-color-2" />
                                </button>
                            </Col>

                            {/* <Col xs={12} lg={3} md={3} sm={12} className="p-0">
                                <button
                                    className="btn page-action-btn  mb-2 w-100"
                                    onClick={(event) => this.exportHandler(event)}
                                >
                                    {Strings["Export"]}
                                </button>
                            </Col> */}

                            {localStorage.getItem("USER_LEVEL") == 2 && (
                                <Col xs={12} lg={2} md={2} sm={12} className="p-0">
                                    <Button
                                        variant="contained"
                                        type="button"
                                        className="refresh-action-btn "
                                        onClick={this.handleRefresh}
                                        title={Strings["Refresh"]}
                                    >
                                        <i className="flaticon-refresh reset-filter-btn"></i>
                                    </Button>
                                </Col>
                            )}

                        </div>
                    </Col>
                </Row>
                {this.state.loading == 0 && this.state.errorMsg != "" && (
                    <Row>
                        <div className="inv-cards-view pb-5 width-100">
                            <div
                                className="text-center"
                                style={{ marginTop: "15%", marginBottom: "15%" }}
                            >
                                <img
                                    alt="Logo"
                                    src={toAbsoluteUrl(
                                        "/media/ezpay/EZPAY_LOGO_GRAY" + window.MAIN_IMAGE + ".png"
                                    )}
                                    className="img-fluid no-data-img"
                                />
                                <div className="no-data-text">{this.state.errorMsg}</div>
                            </div>
                        </div>
                    </Row>
                )}
                {this.state.loading == 0 &&
                    this.state.data && this.state.data.length <= 0 &&
                    this.state.errorMsg == "" && (
                        <Row>
                            <div className="inv-cards-view pb-5 width-100">
                                <div
                                    className="text-center"
                                    style={{ marginTop: "15%", marginBottom: "15%" }}
                                >
                                    <img
                                        alt="Logo"
                                        src={toAbsoluteUrl(
                                            "/media/ezpay/EZPAY_LOGO_GRAY" +
                                            window.MAIN_IMAGE +
                                            ".png"
                                        )}
                                        className="img-fluid no-data-img"
                                    />
                                    <div className="no-data-text">
                                        {Strings["There is no data to display"]}
                                    </div>
                                </div>
                            </div>
                        </Row>
                    )}
                {this.state.loading == 1 && (
                    <Row>
                        <Col lg={12} style={{ marginTop: "7%" }} className="text-center">
                            <div className="card-body">
                                <div
                                    className="spinner-grow text-dark m-2 main-color-1"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-2"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-1"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-2"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-1"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-2"
                                    role="status"
                                ></div>
                            </div>
                        </Col>
                    </Row>
                )}
                {this.state.loading == 0 && this.state.data && this.state.data.length > 0 && (
                    <Row>
                        <div className="inv-cards-view width-100">
                            <Row className="table-header-row d-none d-lg-flex d-md-flex">
                                <Col
                                    lg={1}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Order #"]}
                                >
                                    {Strings["Order #"]}
                                </Col>
                                {localStorage.getItem("USER_LEVEL") == 1 && (
                                    <Col
                                        lg={2}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        className="overflow-text-length"
                                        title={Strings["Distributor Name"]}
                                    >
                                        {Strings["Distributor Name"]}
                                    </Col>
                                )}
                                <Col
                                    lg={col}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["POS Name"]}
                                >
                                    {Strings["POS Name"]}
                                </Col>
                                <Col
                                    lg={col}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Category"]}
                                >
                                    {Strings["Category"]}
                                </Col>

                                <Col
                                    lg={col}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Biller"]}
                                >
                                    {Strings["Biller"]}
                                </Col>
                                <Col
                                    lg={col}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Service Name"]}
                                >
                                    {Strings["Service Name"]}
                                </Col>
                                <Col
                                    lg={col - 1}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length text-center"
                                    title={Strings["Show More"]}
                                >
                                    {Strings["Show More"]}
                                </Col>
                                {/* 
                                {
                                    <Col
                                        lg={3}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        className="overflow-text-length text-right"
                                        title={Strings["Action"]}
                                    >
                                        {Strings["Action"]}
                                    </Col>
                                } */}
                            </Row>
                            {this.state.data.map((rowData, index) => {
                                return (
                                    <Row key={index} className="table-body-row">
                                        <Col
                                            lg={1}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="overflow-text-length  order-2 order-md-1 order-lg-1 "
                                            title={Strings["POS Name"]}
                                        >
                                            <span className="d-inline d-lg-none d-md-none text-bold">
                                                {Strings["Order #"]} :{" "}
                                            </span>
                                            {rowData.orderId}
                                        </Col>
                                        {localStorage.getItem("USER_LEVEL") == 1 && (
                                            <Col
                                                lg={2}
                                                md={12}
                                                sm={12}
                                                xs={12}
                                                className="overflow-text-length order-3 order-md-2 order-lg-2"
                                                title={Strings["Total withdrawn profits"]}
                                            >
                                                <span className="d-inline d-lg-none d-md-none text-bold">
                                                    {Strings["Total withdrawn profits"]} :{" "}
                                                </span>
                                                {rowData.distName}
                                            </Col>
                                        )}
                                        <Col
                                            lg={col}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="overflow-text-length order-1 order-md-3 order-lg-3 text-bold-ssm"
                                            title={Strings["Total unwithdrawn profits"]}
                                        >
                                            <span className="d-inline d-lg-none d-md-none text-bold">
                                                {Strings["POS Name"]} :{" "}
                                            </span>
                                            {rowData.posName}
                                        </Col>
                                        <Col
                                            lg={col}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="overflow-text-length order-1 order-md-3 order-lg-3 text-bold-ssm"
                                            title={Strings["Total unwithdrawn profits"]}
                                        >
                                            <span className="d-inline d-lg-none d-md-none text-bold">
                                                {Strings["Category"]} :{" "}
                                            </span>
                                            {rowData.billerCategory}
                                        </Col>
                                        <Col
                                            lg={col}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="overflow-text-length order-1 order-md-3 order-lg-3 text-bold-ssm"
                                            title={Strings["Total unwithdrawn profits"]}
                                        >
                                            <span className="d-inline d-lg-none d-md-none text-bold">
                                                {Strings["Biller Name"]} :{" "}
                                            </span>
                                            {rowData.billerName}
                                        </Col>
                                        <Col
                                            lg={col}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="overflow-text-length order-1 order-md-3 order-lg-3 text-bold-ssm"
                                            title={Strings["Total unwithdrawn profits"]}
                                        >
                                            <span className="d-inline d-lg-none d-md-none text-bold">
                                                {Strings["Service Type"]} :{" "}
                                            </span>
                                            {rowData.serviceType}
                                        </Col>
                                        <Col
                                            lg={col - 1}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="overflow-text-length order-1 order-md-3 order-lg-3 text-bold-ssm"
                                            title={Strings["Total unwithdrawn profits"]}
                                            style={{ cursor: 'pointer', textAlign: 'center' }}
                                            onClick={() => this.handleShowEFAWATEERcomReportData(rowData)}
                                        >
                                            {eyeIcon()}
                                        </Col>
                                    </Row>
                                );
                            })}
                            {this.state.loading == 0 && this.state.data?.length > 0 && (
                                <Col md={12}>
                                    <Row className="pagenation-view mt-3 mb-4">
                                        <Pagination
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={this.state.limit}
                                            totalItemsCount={this.state.dataCount}
                                            pageRangeDisplayed={4}
                                            onChange={this.handlePageChange}
                                            prevPageText={
                                                <i
                                                    className={
                                                        localStorage.getItem("LANG") == 1
                                                            ? "flaticon2-next"
                                                            : "flaticon2-back"
                                                    }
                                                ></i>
                                            }
                                            nextPageText={
                                                <i
                                                    className={
                                                        localStorage.getItem("LANG") == 1
                                                            ? "flaticon2-back"
                                                            : "flaticon2-next"
                                                    }
                                                ></i>
                                            }
                                            hideFirstLastPages
                                            innerClass={
                                                "pagination  pagination-rounded justify-content-end pagenation-view my-2"
                                            }
                                            itemClass={"page-item"}
                                            linkClass={"page-link"}
                                        />
                                    </Row>
                                </Col>
                            )}
                        </div>
                    </Row>
                )}


                <Drawer
                    anchor={localStorage.getItem("LANG") == 1 ? "left" : "right"}
                    open={this.state.openShowEFAWATEERcomReportData}
                    className={"sidebar-modal-view"}
                >
                    <ShowEFAWATEERcomData
                        data={this.state.showEFAWATEERcomReportData}
                        handleCloseSideBar={() => this.setState({ openShowEFAWATEERcomReportData: false })}
                    />
                </Drawer>
            </div>
        );
    }
}
